export default __webpack_public_path__ + "static/APS_Logo_White_248x284-8935c1a023a3f5f292786bb52cfae37f.png";